import batteryCharging from "@/assets/images/svg-icons/battery-charging.svg";
import batteryFull from "@/assets/images/svg-icons/battery-full.svg";
import batteryWarnig from "@/assets/images/svg-icons/battery-warning.svg";
import gpsOn from "@/assets/images/svg-icons/gps_on.svg";
import gpsOff from "@/assets/images/svg-icons/gps_off.svg";
import {downloadFileFromFirebase} from "../../helpers/firebaseDB";

/**
 * @description Determina el icono para la representacion del nivel de bateria en el infowindow del marker
 * @param {Number} currentLevel nivel de bateria del recurso
 */
const infowindoBatteryLevelIcon = (currentLevel = 0) => {
	//const currentLevel = this.resource_local.footer_text_1;
	if (currentLevel >= 60) {
		return batteryFull;
	} else if (currentLevel < 60 && currentLevel >= 30) {
		return batteryWarnig;
	} else {
		return batteryCharging;
	}
};

/**
 * @description Determina el icono para la representacion del estado del gps en el infowindow del marker
 * @param {Number} currentStatus Estado del gps del recurso
 */
const infowindoGpsStatusIcon = (currentStatus = "off") => {
	//const currentStatus = this.resource_local.footer_text_1;
	if (currentStatus === "on") {
		return gpsOn;
	} else {
		return gpsOff;
	}
};

/**
 * @description Genera el contenido html del infowindow del marker
 * @param {Object} dataObject Json object con las propiedades de un recurso
 * @param {Function} callback funcion para recoger los datos del infowindow desde el componente que lo invoca
 */
export const infowindowContentResource = function (dataObject, callback) {
	// Diseño del contenido html del infowindows
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	$infowindowDivContent.setAttribute("id", `infoWindow-resource-${dataObject.id}`);
	let $contentHeader = document.createElement("div");
	let $contentFotter = document.createElement("div");
	let $contentRight = document.createElement("div");
	let $contentLeft = document.createElement("div");
	let $contentIcons = document.createElement("div");
	let $title = document.createElement("h3");
	let $distance = document.createElement("h5");
	let $name = document.createElement("p");
	let $events = document.createElement("p");
	let $avatar = document.createElement("img");
	let $batteryLevel = document.createElement("img");
	let $gpsStatus = document.createElement("img");
	let $button = document.createElement("button");
	// Set id and class attribite
	$title.setAttribute("class", "g-subtitle");
	$contentHeader.setAttribute("id", `infoWindow-${dataObject.username}`);
	$contentHeader.setAttribute("class", "g-label--normal");
	$distance.setAttribute("class", "g-label--normal");
	$button.setAttribute("id", "btn-with-loading");
	$button.setAttribute(
		"class",
		"vs-button vs-button-primary vs-button-filled small vs-con-loading__container includeIcon"
	);
	if (Object.hasOwn(dataObject, "img_url") && dataObject.img_url) $avatar.setAttribute("src", dataObject.img_url);
	else $avatar.setAttribute("src", require("@/assets/images/portrait/small/user-avatar.png"));
	$batteryLevel.setAttribute("src", infowindoBatteryLevelIcon(dataObject.battery));
	$gpsStatus.setAttribute("src", infowindoGpsStatusIcon(dataObject.gps));
	$avatar.className = "infowindow-avatar";
	// Set Css styles
	$contentHeader.style.cssText = `display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 5px;
    text-align: center;`;
	$distance.style.cssText = "color: green;";
	$contentRight.style.cssText = "margin-left: 0px;";
	$contentIcons.style.cssText = `margin-top: 5px; display: flex; justify-content: center;`;
	$avatar.style.cssText = "width: 65px;border-radius: 50%;margin: 10px";
	$button.style.cssText = `
    margin-top: 5px;
    padding: 10px;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    font-size: 1rem;
    width: 150px;`;
	// Set button events
	$button.addEventListener("click", function (e) {
		callback(dataObject);
	});
	// Set content to elements
	$name.textContent = `${dataObject.name} ${dataObject.lastname}`.toUpperCase();
	$events.textContent = Object.hasOwn(dataObject, "events")
		? `${this.$t("Alarm.TotalVisit")}: ${dataObject.events}`
		: "";
	$title.textContent = dataObject.username;
	$distance.textContent = Object.hasOwn(dataObject, "distance")
		? ` ${this.$t("OnDemand.Distance")}: ${dataObject.distance} Km`
		: "";
	$button.textContent = `${this.$t("VisitPointObject.Assig")}`;
	$contentRight.appendChild($title);
	$contentRight.appendChild($name);
	$contentRight.appendChild($events);
	$contentRight.appendChild($distance);
	$contentLeft.appendChild($avatar);
	$contentHeader.appendChild($contentLeft);
	$contentHeader.appendChild($contentRight);
	$contentHeader.appendChild($button);
	$docFragment.appendChild($contentHeader);
	$docFragment.appendChild($contentFotter);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};

export const generateInfowindowContentSchedule = (infoWindowData) => {
	// Diseño del contenido html del infowindows
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	$infowindowDivContent.setAttribute("id", "infoWindow");
	$infowindowDivContent.style.cssText = "text-align: center";
	let $title = document.createElement("h4");
	$title.textContent = `Start at ${infoWindowData.init_hour}`;
	let $name = document.createElement("p");
	let $visitPoint = document.createElement("p");
	let $address = document.createElement("p");
	$name.textContent = `${infoWindowData.activity_name}`;
	$visitPoint.textContent = `${infoWindowData.visit_point_name}`;
	$address.textContent = `${infoWindowData.address}`;
	$docFragment.appendChild($title);
	$docFragment.appendChild($name);
	$docFragment.appendChild($visitPoint);
	$docFragment.appendChild($address);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
export const generateInfowindowContentVisitPoints = (infoWindowData) => {
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	let $title = document.createElement("h4");
	let $name = document.createElement("p");
	let $city = document.createElement("p");
	let $address = document.createElement("p");
	$infowindowDivContent.setAttribute("id", `infoWindow-vp-${infoWindowData.id}`);
	$infowindowDivContent.style.cssText = "text-align: center; width:150px; padding: 5px";
	$title.textContent = `${infoWindowData.name}`;
	$city.textContent = `${infoWindowData.city}`;
	$address.textContent = `${infoWindowData.address}`;
	$docFragment.appendChild($title);
	$docFragment.appendChild($name);
	$docFragment.appendChild($city);
	$docFragment.appendChild($address);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};

const getResourcePhoto = async (img_url) => {
	const url = img_url;
	if (!url) {
		return require("@/assets/images/portrait/small/user-avatar.png");
	}
	const publicUrl = await downloadFileFromFirebase(url);
	return publicUrl;
};

export const generateInfowindowRouteLineal = (infoWindowData, options) => {
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	let $date = document.createElement("p");
	let $hour = document.createElement("p");
	let $distance = document.createElement("span");
	let $rasterNum = document.createElement("span");

	$rasterNum.setAttribute("class", "flex items-center w-full");

	$date.innerHTML = `<span class="g-table--title">${options.dateText}: </span><span class="g-label--normal">${infoWindowData.date}</span>`;
	$hour.innerHTML = `<span class="g-table--title">${options.hourText}: </span><span class="g-label--normal">${infoWindowData.time}</span>`;
	$distance.innerHTML = `<span class="g-table--title">${options.distanceText}: </span><span class="g-label--normal">${
		infoWindowData.valueDistance + " " + "Km"
	}</span>`;
	$rasterNum.innerHTML = `<span class="g-table--title truncate select-none mr-1">${
		options.rasterText
	}: </span><div class="con-vs-chip vs-chip-primary con-color text-primary"><span class="text-chip vs-chip--text text-white">${
		infoWindowData.rasterNum + " " + options.of + " " + infoWindowData.totalRaster
	}</span></div>`;

	$docFragment.appendChild($date);
	$docFragment.appendChild($hour);
	$docFragment.appendChild($distance);
	$docFragment.appendChild($rasterNum);

	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};

/**
 * @description Genera el contenido html del infowindow del marker
 * @param {Object} dataObject Json object con las propiedades de un recurso
 * @param {Function} callback funcion para recoger los datos del infowindow desde el componente que lo invoca
 */
export const infowindowContentResourceOnDemand = function (dataObject) {
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	$infowindowDivContent.setAttribute("id", `infoWindow-resource-${dataObject.uid}`);
	let $contentHeader = document.createElement("div");
	let $contentFotter = document.createElement("div");
	let $contentRight = document.createElement("div");
	let $contentLeft = document.createElement("div");
	let $contentIcons = document.createElement("div");
	let $title = document.createElement("h3");
	let $name = document.createElement("p");
	let $avatar = document.createElement("img");
	$contentHeader.setAttribute("id", `infoWindow-${dataObject.username}`);
	if (Object.hasOwn(dataObject, "img_url") && dataObject.img_url) $avatar.setAttribute("src", dataObject.img_url);
	else $avatar.setAttribute("src", require("@/assets/images/portrait/small/user-avatar.png"));
	$avatar.className = "infowindow-avatar";
	// Set Css styles
	$contentHeader.style.cssText = `display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgb(243, 243, 243);
    border-radius: 5px;
    padding: 10px;
    text-align: center;`;
	$contentRight.style.cssText = "margin-left: 0px;";
	$contentIcons.style.cssText = `margin-top: 10px;
    display: flex;
  justify-content: center;`;
	$avatar.style.cssText = "width: 75px; height: 75px; border-radius: 50%;margin: 10px";
	// Set content to elements
	$name.textContent = `${dataObject.name} ${dataObject.lastname}`;
	$title.textContent = dataObject.username;
	$contentRight.appendChild($title);
	$contentRight.appendChild($name);
	$contentLeft.appendChild($avatar);
	$contentHeader.appendChild($contentLeft);
	$contentHeader.appendChild($contentRight);
	$docFragment.appendChild($contentHeader);
	$docFragment.appendChild($contentFotter);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
export const infowindowContentLayerCarto = function (data) {
	// Diseño del contenido html del infowindows
	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	$infowindowDivContent.setAttribute("class", `widget`);
	let $title = document.createElement("h2");
	$title.setAttribute("class", "g-subtitle");
	$title.textContent = data.name;
	$infowindowDivContent.appendChild($title);
	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
const batteryIcon = (level) => {
	if (level >= 60) {
		return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery h-7 w-7 stroke-current text-success"><rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line></svg>`;
	} else if (level < 60 && level >= 30) {
		return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery h-7 w-7 stroke-current text-warning"><rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line></svg>`;
	} else {
		return `<svg data-v-25c71de1="" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-battery-charging h-8 w-8 stroke-current text-danger"><path data-v-25c71de1="" d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line data-v-25c71de1="" x1="23" y1="13" x2="23" y2="11"></line><polyline data-v-25c71de1="" points="11 6 7 12 13 12 9 18"></polyline></svg>`;
	}
};
const transmissionIcon = (status) =>
	`<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-wifi h-7 w-7 stroke-current text-${
		status ? "success" : "danger"
	}"><path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line></svg>`;

const gpsIcon = (status) =>
	`<i class="vs-icon notranslate icon-scale mt-1 material-icons small vs-icon-${
		status === "on" ? "success" : "danger"
	} bg-small vs-icon-bg">gps_fixed</i>`;

export const infoWindowContentResourceTracking = function (resource, tracking, callbackClick) {
	// Diseño del contenido html del infowindows
	let color = "success";
	let $divBattery = document.createElement("div");
	let $divTransmission = document.createElement("div");
	let $divGps = document.createElement("div");

	let $spanBattery = document.createElement("span");
	let $spanBatteryText = document.createElement("span");
	let $spanTransmission = document.createElement("span");
	let $spanTransmissionText = document.createElement("span");
	let $spanGps = document.createElement("span");
	let $spanGpsText = document.createElement("span");

	let $docFragment = document.createDocumentFragment();
	let $infowindowDivContent = document.createElement("div");
	$infowindowDivContent.setAttribute("id", `infoWindow-resource-${tracking.positionrecord_id}`);

	let $contentHeader = document.createElement("div");
	let $contentFotter = document.createElement("div");

	let $contentRight = document.createElement("div");
	let $contentLeft = document.createElement("div");
	let $contentIcons = document.createElement("div");

	let $title = document.createElement("h2");

	let $name = document.createElement("p");
	let $avatar = document.createElement("img");

	// Set id and class attribite
	$contentHeader.setAttribute("id", `infoWindow-${resource.username}`);
	$spanBattery.setAttribute("id", `span-battery-${tracking.positionrecord_id}`);
	$spanTransmission.setAttribute("id", `span-transmission-${tracking.positionrecord_id}`);
	$spanGps.setAttribute("id", `span-gps-${tracking.positionrecord_id}`);

	$spanBatteryText.setAttribute("id", `span-battery-text-${tracking.positionrecord_id}`);
	$spanTransmissionText.setAttribute("id", `span-transmission-text-${tracking.positionrecord_id}`);
	$spanGpsText.setAttribute("id", `span-gps-text-${tracking.positionrecord_id}`);

	if (Object.hasOwn(resource, "img_url") && resource.img_url) $avatar.setAttribute("src", resource.img_url);
	else $avatar.setAttribute("src", require("@/assets/images/portrait/small/user-avatar.png"));

	$avatar.className = "infowindow-avatar";

	// Set Css styles
	$contentHeader.style.cssText = `
    padding: 10px;
    text-align: center;`;

	$contentRight.style.cssText = "margin-left: 0px;";
	$contentIcons.style.cssText = `
	margin: 10px 0px 10px 0px;
    display: flex;
    justify-content: space-around;`;

	$avatar.style.cssText = "width: 75px; height: 75px; border-radius: 50%;margin: 10px";
	$divBattery.style.cssText =
		"display: flex; align-items: center; width: auto; margin: 1rem; flex-direction: column;";
	$divTransmission.style.cssText =
		"display: flex; align-items: center; width: auto; margin: 1rem; flex-direction: column;";
	$divGps.style.cssText = "display: flex; align-items: center; width: auto; margin: 1rem; flex-direction: column;";

	$title.setAttribute("class", "font-bold");
	$spanBattery.setAttribute("class", "feather-icon select-none relative mr-1");
	$spanTransmission.setAttribute("class", "feather-icon select-none relative mr-1");
	$spanGps.setAttribute("class", "feather-icon select-none relative mr-1");

	$spanBatteryText.setAttribute("class", "text-sm");
	$spanTransmissionText.setAttribute("class", "text-sm");
	$spanGpsText.setAttribute("class", "text-sm");

	// Set content to elements
	$name.textContent = `${resource.email}`;
	$title.textContent = resource.username;
	$spanBatteryText.textContent = tracking.battery + "%";
	$spanTransmissionText.textContent = tracking.active ? this.$t("MapModule.OnLine") : this.$t("MapModule.OffLine");
	$spanGpsText.textContent =
		tracking.gps === "on"
			? this.$t("StatusMobile.ListStatusMobile.Active")
			: this.$t("StatusMobile.ListStatusMobile.Disabled");
	$spanBattery.innerHTML = batteryIcon(+tracking.battery);
	$spanTransmission.innerHTML = transmissionIcon(tracking.active);
	$spanGps.innerHTML = gpsIcon(tracking.gps);

	$contentRight.appendChild($title);
	$contentRight.appendChild($name);

	$divBattery.appendChild($spanBattery);
	$divBattery.appendChild($spanBatteryText);

	$divTransmission.appendChild($spanTransmission);
	$divTransmission.appendChild($spanTransmissionText);

	$divGps.appendChild($spanGps);
	$divGps.appendChild($spanGpsText);

	$contentIcons.appendChild($divTransmission);
	$contentIcons.appendChild($divBattery);
	$contentIcons.appendChild($divGps);
	$contentLeft.appendChild($avatar);

	$contentHeader.appendChild($contentLeft);
	$contentHeader.appendChild($contentRight);
	$contentHeader.appendChild($contentIcons);

	$docFragment.appendChild($contentHeader);
	$docFragment.appendChild($contentFotter);

	$infowindowDivContent.appendChild($docFragment);
	return $infowindowDivContent;
};
